// Action Types for Video Rendering
export const START_VIDEO_RENDER_REQUEST = "START_VIDEO_RENDER_REQUEST";
export const START_VIDEO_RENDER_SUCCESS = "START_VIDEO_RENDER_SUCCESS";
export const START_VIDEO_RENDER_FAILURE = "START_VIDEO_RENDER_FAILURE";

export const GET_RENDER_PROGRESS_REQUEST = "GET_RENDER_PROGRESS_REQUEST";
export const GET_RENDER_PROGRESS_SUCCESS = "GET_RENDER_PROGRESS_SUCCESS";
export const GET_RENDER_PROGRESS_FAILURE = "GET_RENDER_PROGRESS_FAILURE";

export const GET_RENDER_DOWNLOAD_URL_REQUEST =
  "GET_RENDER_DOWNLOAD_URL_REQUEST";
export const GET_RENDER_DOWNLOAD_URL_SUCCESS =
  "GET_RENDER_DOWNLOAD_URL_SUCCESS";
export const GET_RENDER_DOWNLOAD_URL_FAILURE =
  "GET_RENDER_DOWNLOAD_URL_FAILURE";

export const RESET_RENDER_STATE = "RESET_RENDER_STATE";

// Start Video Render
export const startVideoRenderRequest = (payload) => {
  console.log("📤 ACTION: startVideoRenderRequest dispatched:", {
    type: START_VIDEO_RENDER_REQUEST,
    payload: {
      ...payload,
      inputPropsKeys: payload.inputProps
        ? Object.keys(payload.inputProps)
        : null,
    },
  });
  return {
    type: START_VIDEO_RENDER_REQUEST,
    payload,
  };
};

export const startVideoRenderSuccess = (response) => {
  console.log("✅ ACTION: startVideoRenderSuccess dispatched:", {
    type: START_VIDEO_RENDER_SUCCESS,
    payload: response,
  });
  return {
    type: START_VIDEO_RENDER_SUCCESS,
    payload: response,
  };
};

export const startVideoRenderFailure = (error) => {
  console.error("❌ ACTION: startVideoRenderFailure dispatched:", {
    type: START_VIDEO_RENDER_FAILURE,
    payload: error,
  });
  return {
    type: START_VIDEO_RENDER_FAILURE,
    payload: error,
  };
};

// Get Render Progress
export const getRenderProgressRequest = (payload) => {
  console.log("📤 ACTION: getRenderProgressRequest dispatched:", {
    type: GET_RENDER_PROGRESS_REQUEST,
    payload,
  });
  return {
    type: GET_RENDER_PROGRESS_REQUEST,
    payload,
  };
};

export const getRenderProgressSuccess = (response) => {
  console.log("✅ ACTION: getRenderProgressSuccess dispatched:", {
    type: GET_RENDER_PROGRESS_SUCCESS,
    payload: response,
  });
  return {
    type: GET_RENDER_PROGRESS_SUCCESS,
    payload: response,
  };
};

export const getRenderProgressFailure = (error) => {
  console.error("❌ ACTION: getRenderProgressFailure dispatched:", {
    type: GET_RENDER_PROGRESS_FAILURE,
    payload: error,
  });
  return {
    type: GET_RENDER_PROGRESS_FAILURE,
    payload: error,
  };
};

// Get Render Download URL
export const getRenderDownloadUrlRequest = (payload) => ({
  type: GET_RENDER_DOWNLOAD_URL_REQUEST,
  payload,
});

export const getRenderDownloadUrlSuccess = (response) => ({
  type: GET_RENDER_DOWNLOAD_URL_SUCCESS,
  payload: response,
});

export const getRenderDownloadUrlFailure = (error) => ({
  type: GET_RENDER_DOWNLOAD_URL_FAILURE,
  payload: error,
});

// Reset Render State
export const resetRenderState = () => ({
  type: RESET_RENDER_STATE,
});
